module.exports = __webpack_public_path__ + "img/logo.f0e09ff3.png";